import { EditCheckListModelTaskDTO } from '../CheckListModelTask/EditCheckListModelTaskDTO';
import Joi from "joi";

export interface EditCheckListModelDTO {
  id: number;
  title?: string;
  brand?: string;
  model?: string;
  active?: boolean;
}

export const EditCheckListModelDTOSchema = Joi.object({
  id: Joi.number().required().messages({
    "any.required": "Id é obrigatório",
    "number.base": "Id deve ser um número",
  }),

  title: Joi.string().trim().required().messages({
    "string.base": "Título deve ser texto",
    "string.empty": "Título é obrigatório",
    "any.required": "Título é obrigatório",
  }),

  model: Joi.string()
    .allow(null, "")
    .optional()
    .custom((value, helpers) => {
      if (value === null || value === "") return value;
      if (typeof value !== "string") return helpers.error("string.base");
      if (value.trim().length > 60) return helpers.error("string.max");
      return value;
    })
    .messages({
      "string.base": "Modelo deve ser texto",
      "string.max": "Modelo não pode ter mais de 60 caracteres",
    }),

  brand: Joi.alternatives().conditional("model", {
    switch: [
      {
        is: Joi.string().trim().min(1),
        then: Joi.string()
          .trim()
          .min(1)
          .required()
          .messages({
            "string.empty": "A marca é obrigatória quando o modelo é providenciado",
            "any.required": "A marca é obrigatória quando o modelo é providenciado",
          }),
      },
    ],
    otherwise: Joi.string()
      .allow(null, "")
      .optional()
      .messages({
        "string.base": "Marca deve ser texto",
      }),
  }),

  active: Joi.boolean().optional().messages({
    "boolean.base": "O campo ativo deve ser verdadeiro ou falso",
  }),
});